/**
 * 权限相关
 * Filename: auth.js
 * Author: GaoYu
 * Time: 2020/7/14 10:52
 */
import aes from './aes'
import md5 from 'js-md5'

const identifyKey = 'eeIdentify'
const tokenKey = 'eeAccessToken'

const getIdentify = () => {
  let identify = window.localStorage.getItem(identifyKey)
  return identify || ''
}

const setIdentify = (identify) => {
  window.localStorage.setItem(identifyKey, identify)
}

const getToken = () => {
  return window.localStorage.getItem(tokenKey)
}

const setToken = (token) => {
  window.localStorage.setItem(tokenKey, token)
}

const getClientType = () => {
  return 'web'
}

const generateMixed = (n) => {
  const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  let res = ''
  for (let i = 0; i < n; i++) {
    let id = Math.ceil(Math.random() * 35)
    res += chars[id]
  }
  return res
}

const getSignTime = () => {
  let diffTime = window.sessionStorage.getItem('diff_time') // 相差时间
  let localTime = new Date().valueOf() // 本地时间
  if (diffTime && diffTime !== 'NaN') { // 有差距时间
    return localTime + diffTime
  }
  return localTime
}

const getReqSign = () => {
  const random = generateMixed(16)
  const time = getSignTime()
  const clientType = getClientType()
  const key = md5(clientType + random + time)
  return aes.aesEncrypt('client_type=' + clientType + '&random=' + random + '&time=' + time + '&key=' + key)
}

const getWxState = (backUrl) => {
  let singParam = 'utRWZBhNvI'
  let state = {
    back: backUrl,
    sign: md5(backUrl + singParam)
  }
  return btoa(JSON.stringify(state))
}

export default {
  getClientType,
  getReqSign,
  getIdentify,
  setIdentify,
  getWxState,
  getToken,
  setToken
}



// WEBPACK FOOTER //
// ./src/utils/auth.js